module.exports = __webpack_public_path__ + "files/80484522b3143865b5aba83197e5f305.svg";